import React, { Component } from "react";
import AffiliateDataService from "../services/affiliate.service";
import SiteLogo from "../images/logo.png";

export default class SiteLogin extends Component {
  constructor(props) {
    super(props);
    this.onChangeCaptcha = this.onChangeCaptcha.bind(this);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.saveLoginDetails = this.saveLoginDetails.bind(this);

    this.state = {
      userName: "",
      passWord: "",
      c1: Math.floor(Math.random() * 10),
      c2: Math.floor(Math.random() * 10),
      captchaAns: "",
      loginErr: "",
      registered: localStorage.getItem('registered'),
      activated: false,
      authenticated: localStorage.getItem('authenticated')
    };
  }

  componentDidMount() {
    console.log("Registered " + this.state.registered);
    var verifyAffId = this.getQueryVariable('verify');
    if(verifyAffId != ''){
      this.activateAffiliate(verifyAffId);
    }
    if (this.state.authenticated === "true") {
      window.location = "dashboard";
      return false;
    }
  }
  
  getQueryVariable(ref) {
    var query = window.location.search.substring(1);
    console.log(query)//"app=article&act=news_content&aid=160990"
    var vars = query.split("&");
    console.log(vars) //[ 'app=article', 'act=news_content', 'aid=160990' ]
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      console.log(pair)//[ 'app', 'article' ][ 'act', 'news_content' ][ 'aid', '160990' ] 
      if (pair[0] == ref) { return pair[1]; }
    }
    return (false);
  }
  
  activateAffiliate(validateAffId) {
    AffiliateDataService.activateAffiliateById(validateAffId)
      .then(response => {
        if (response.data.success === true) {
          this.setState({
            activated: "true",
            registered: "false"
          });
          return false;
        }
        else {
          this.setState({
            registered: "false",
            activated: "false",
            loginErr: response.data.message
          });

        }
      })
      .catch(e => {
        console.log(e);
      });
  }

  onChangeCaptcha(e) {
    this.setState({
      captchaAns: e.target.value
    });
  }

  onChangeUsername(e) {
    this.setState({
      userName: e.target.value
    });
  }

  onChangePassword(e) {
    this.setState({
      passWord: e.target.value
    });
  }

  saveLoginDetails() {
    this.setState({
      registered: ""
    });

    if(this.state.userName === ""){
      this.setState({
        loginErr: "Username required!"
      });
      return false;
    }
    if(this.state.passWord === ""){
      this.setState({
        loginErr: "Password required!"
      });
      return false;
    }

    var expectedAns = (this.state.c1 + this.state.c2);
    if (expectedAns != this.state.captchaAns) {
      this.setState({
        loginErr: "Wrong Captcha Answer!"
      });
      return false;
    }

    var data = {
      userName: this.state.userName,
      passWord: this.state.passWord,
    };

    console.log(data);

    AffiliateDataService.login(data.userName, data.passWord)
      .then(response => {
        this.setState({
          userName: response.userName,
          passWord: response.passWord,
          submitted: true
        });
        if (response.data.success === true) {
          localStorage.setItem("payoutRequest", response.data.model.payout_request);
          localStorage.setItem("minimumPayout", response.data.minimum_payout);
          localStorage.setItem("authenticated", true);
          localStorage.setItem("userName", response.data.model.username);
          localStorage.setItem("userTotal", (response.data.currentUserTotal > 0 ? response.data.currentUserTotal : 0));
          localStorage.setItem("userAffiliateCode", response.data.model.aff_code);
          localStorage.setItem("userSignUpLink", response.data.signuplink);
          localStorage.setItem("userOrderLink", response.data.orderlink);
          localStorage.setItem("paypalEmail", response.data.model.paypal_email);
          localStorage.setItem("allPayoutRequests", response.data.allPayoutRequests);
          localStorage.setItem("payoutReqModel", JSON.stringify(response.data.payoutReqModel));
          localStorage.setItem("previousPayoutRequestModel", response.data.previousPayoutRequestModel);
          localStorage.setItem("shareTitle", response.data.signupTitle);
          localStorage.setItem("shareOrderTitle", response.data.orderTitle);
          localStorage.setItem("userRole", response.data.model.role);
          window.location.href = "dashboard";
        }
        else {
          this.setState({
            loginErr: response.data.message
          });
        }
        //console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  }

  render() {
    const { activated, registered, loginErr, captchaAns, c1, c2 } = this.state;
    return (
      <div className="login">
        <div className="container">
          <div className="row">
            <div className="col-md-6 offset-md-3 col-lg-4 offset-lg-4">
              <div className="login-boxed">
                <div className="site-logo">
                  <img src={SiteLogo} alt="logo" className="img-fluid" />
                </div>
                <div className="login-box">
                  <div>
                    {activated === "true" || activated === true ? (<h6 className="alert alert-success">Email verified!</h6>) : ""}
                    {registered === "true" || registered === true ? (<h6 className="alert alert-success">Registered Successfully!</h6>) : ""}
                    {loginErr !== "" ? <h5 className="text text-danger">{loginErr}</h5> : ""}
                    <label>Username</label>
                    <input
                      type="text"
                      className="form-control"
                      id="userName"
                      required
                      value={this.state.userName}
                      onChange={this.onChangeUsername}
                      name="userName"
                    />
                  </div>
                  <div>
                    <label>Password</label>
                    <input
                      type="password"
                      className="form-control"
                      id="passWord"
                      required
                      value={this.state.passWord}
                      onChange={this.onChangePassword}
                      name="passWord"
                    />
                  </div>
                  <div>
                    <label>Captcha</label>
                    <div className="border border-primary bg bg-dark text text-warning p-1 mb-1">
                      <strong>{c1}</strong> + <strong>{c2}</strong>
                    </div>
                    <input
                      type="text"
                      maxLength={2}
                      className="form-control"
                      id="captchaAns"
                      required
                      value={captchaAns}
                      onChange={this.onChangeCaptcha}
                      name="captchaAns"
                    />
                  </div>
                  <input onClick={this.saveLoginDetails} type="submit" name="login" value="Login" />
                  <div className="su-div">
                  <p>Not a member? <a href="/register">Signup Now</a></p>
                  <p><a href="/forgot-password">Forgot Password?</a></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
